import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
	apiKey: "AIzaSyBz5lGhJUK11bYvwfJTjhMk9G2LbntbC3A",
	authDomain: "tiluchi-service.firebaseapp.com",
	databaseURL: "https://needex.firebaseio.com/",
	projectId: "tiluchi-service",
	storageBucket: "tiluchi-service.appspot.com",
	messagingSenderId: "207082968380",
	appId: "1:207082968380:web:e552a6f9e1d71103af7a39",
	measurementId: "G-J99RPFMG0Y"
};

// Initialize Firebase and Firebase Authentication
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase();

export { auth, database };
